import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import TypewriterText from "../components/TypeWriterText";

const pages = [
  { title: " Curators Foreword", path: "/foreword-lightningtech" },

  {
    title: "Day 91: A Primer on What The Lightning Network is",
    path: "/lightning-91",
  },
  {
    title: "Day 92: Setting up a Lightning Wallet (Hands on)",
    path: "/lightning-92",
  },
  {
    title: "Day 93: Understanding Lightning Channels",
    path: "/lightning-93",
  },
  {
    title: "Day 94: Atomic Payments and Penalty Mechanisms",
    path: "/lightning-94",
  },
  {
    title: "Day 95: Lightning Network : The Altcoin Killer",
    path: "/lightning-95",
  },
];

const IndexLightning = () => {
  // State for staggered animation
  const [visibleItems, setVisibleItems] = useState([]);
  // State for hover tracking
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Custom title text for the secondary title
  const titleText = "Fundamentals of Lightning Tech";

  // Staggered animation effect
  useEffect(() => {
    pages.forEach((_, index) => {
      const delay = 50 * index;
      const timeoutId = setTimeout(() => {
        setVisibleItems((prevItems) => [...prevItems, index]);
      }, delay);
      return () => clearTimeout(timeoutId);
    });
  }, []);

  // Define the base style object for all links (matching IndexEconomics)
  const baseLinkStyle = {
    fontSize: "18px",
    width: "100%",
    padding: "15px 20px",
    margin: "0",
    textDecoration: "none",
    borderBottom: "1px solid #eee",
    color: "black",
    cursor: "pointer",
    textAlign: "left",
    transition:
      "color 0.3s ease, background-color 0.3s ease, transform 0.3s ease, opacity 0.5s ease, border-color 0.3s ease",
  };

  // Define the hover style (matching IndexEconomics)
  const hoverStyle = {
    backgroundColor: "#f9f9f9",
    color: "#034d28", // Dark Green text on hover
    transform: "translateX(5px)", // Subtle slide-right effect
    borderBottomColor: "#034d28", // Dark Green border on hover
  };

  return (
    <div
      style={{
        width: "95%",

        margin: "40px auto",
        padding: "0", // Remove padding to allow links to touch edges
        backgroundColor: "white",
        border: "2px solid #ccc",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch", //
        fontFamily: "Georgia, sans-serif",
        lineHeight: "1.6",
        letterSpacing: "0.3px",
      }}
    >
      <h1
        style={{
          fontSize: "30px",
          fontWeight: "bold",
          textAlign: "center",
          marginBottom: "20px",
          marginTop: "20px",
          color: "black",
          padding: "0 20px", // Add padding back to the title
        }}
      >
        <b>Table of Contents</b>
        <br />
        <TypewriterText text={titleText} delay={80} />
      </h1>
      {pages.map((page, index) => {
        const isVisible = visibleItems.includes(index);
        const isHovered = hoveredIndex === index;

        return (
          <Link
            key={index}
            to={page.path}
            // Merge base style, animation style, and hover style
            style={{
              ...baseLinkStyle,
              // Animation style (fade in and slide up)
              ...(isVisible
                ? {}
                : { opacity: 0, transform: "translateY(20px)" }),
              // Hover style
              ...(isHovered ? hoverStyle : {}),
            }}
            // Hover handlers
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            {page.title}
          </Link>
        );
      })}
    </div>
  );
};

export default IndexLightning;
